import * as React from 'react'

import { Box, Spinner, Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useForm } from 'modules/enps/hooks/useForm'
import { useQuestionGroup } from 'modules/enps/hooks/useQuestionGroup'
import ResponseQuestionsWrapper from 'modules/enps/pages/AnswersPage/Response/ResponseQuestionsWrapper'
import type Form from 'modules/enps/store/models/Form'
import type { InboxRequest } from 'modules/notifications/hooks/useNotificationsRequests'
import UserBlock from 'modules/surveys/components/UserBlock'
import type QuestionGroup from 'modules/surveys/store/models/QuestionGroup'

interface Props {
  request: InboxRequest
  removeRequestById: (id: string) => void
}

const CollapseContent = ({ request, removeRequestById }: Props) => {
  const { loading, questionGroup } = useQuestionGroup(Number(request.resourceIdentifier))
  const [refreshForm, setRefreshForm] = React.useState<boolean>(true)
  const { loading: loadingForm, form } = useForm(refreshForm, setRefreshForm)

  const onDraftSaved = async () => removeRequestById(request.id)

  if (loading && loadingForm) {
    return <Spinner />
  }

  return (
    <Box flexDirection="row" gap="s40">
      <Box width="full" gap="s80">
        <Title
          illustration="love-hands"
          title={i18n.t('notifications.inbox.tasks.pending_question_group_enps.title')}
          description={i18n.t('notifications.inbox.tasks.pending_question_group_enps.description')}
        />
      </Box>

      <Box width="full" minWidth="s600">
        {questionGroup && form && (
          <UserBlock user={null}>
            <ResponseQuestionsWrapper
              form={form as Form}
              questionGroup={questionGroup as QuestionGroup}
              onDraftSaved={onDraftSaved}
            />
          </UserBlock>
        )}
      </Box>
    </Box>
  )
}

export default CollapseContent
